import { render, staticRenderFns } from "./CourseLevel.vue?vue&type=template&id=b8ac748c&"
import script from "./CourseLevel.vue?vue&type=script&lang=js&"
export * from "./CourseLevel.vue?vue&type=script&lang=js&"
import style0 from "./CourseLevel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports